import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { BrandMark } from "@/components/BrandMark";
import { api, apiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen legacy-bg">
      <Navbar />
      <main className="max-w-lg mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="glass-card p-7 sm:p-9 fade-up" data-testid="forgot-card">
          <div className="flex justify-center mb-5"><BrandMark size={56} /></div>
          <h1 className="font-serif text-3xl sm:text-4xl text-center text-[#EDE6F7] mb-3">Forgot your password?</h1>
          {sent ? (
            <div className="text-center">
              <MailCheck className="h-10 w-10 mx-auto text-[#B57BFF] mb-4" aria-hidden="true" />
              <p role="status" className="text-lg text-[#D9C6FF] leading-relaxed" data-testid="forgot-sent">{sent}</p>
              <p className="mt-3 text-[#A49CB8]">The link works once and expires in 1 hour. Remember to check your spam folder.</p>
            </div>
          ) : (
            <>
              <p className="text-center text-lg text-[#B9B3C8] mb-7">Enter your email address and we'll send you a secure link to choose a new password.</p>
              <form onSubmit={submit} className="space-y-5">
                <div>
                  <label htmlFor="forgot-email" className="eyebrow block mb-2">Email address</label>
                  <input id="forgot-email" data-testid="forgot-email" type="email" required autoComplete="email" value={email}
                    onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com"
                    className="w-full h-14 px-4 rounded-xl bg-[#1A1222] border border-[#33264A] text-[#EDE6F7] text-lg focus:outline-none focus:border-[#8B2CFF] focus:ring-2 focus:ring-[rgba(139,44,255,0.35)]" />
                </div>
                {error && <p role="alert" className="text-[#E6CCF2]" data-testid="forgot-error">{error}</p>}
                <button type="submit" disabled={loading} data-testid="forgot-submit" className="gold-btn w-full h-16 rounded-full text-xl disabled:opacity-60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#EDE6F7]">
                  {loading ? "Sending…" : "Send reset link"}
                </button>
              </form>
            </>
          )}
          <p className="mt-7 text-center">
            <Link to="/signin?mode=login" data-testid="forgot-back-login" className="gold-text font-semibold underline underline-offset-4">Back to log in</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
